var chunkMapping = {
	"163": [
		6765
	],
	"308": [
		8618,
		8999
	],
	"337": [
		111
	],
	"411": [
		7693,
		8136
	],
	"422": [
		205,
		438,
		1335,
		1945,
		2147,
		4375,
		4686,
		4963,
		9300,
		9493
	],
	"467": [
		6467
	],
	"644": [
		368,
		2008,
		2591
	],
	"983": [
		8513
	]
};
var idToExternalAndNameMapping = {
	"111": [
		"default",
		"./Badge",
		3071
	],
	"205": [
		"default",
		"./Drawer",
		3071
	],
	"368": [
		"default",
		"./icons/SwapHorizRemove",
		3071
	],
	"438": [
		"default",
		"./icons/ExternalLink",
		3071
	],
	"1335": [
		"default",
		"./Text",
		3071
	],
	"1945": [
		"default",
		"./Empty",
		3071
	],
	"2008": [
		"default",
		"./constants",
		1441
	],
	"2147": [
		"default",
		"./Menu",
		3071
	],
	"2591": [
		"default",
		"./Tooltip",
		3071
	],
	"4375": [
		"default",
		"./icons/Remove",
		3071
	],
	"4686": [
		"default",
		"./MenuItem",
		3071
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6765": [
		"default",
		"./Avatar",
		3071
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"8136": [
		"default",
		"./icons/SwapHoriz",
		3071
	],
	"8513": [
		"default",
		"./Icon",
		3071
	],
	"8618": [
		"default",
		"./Button",
		3071
	],
	"8999": [
		"default",
		"./Message",
		3071
	],
	"9300": [
		"default",
		"./Alert",
		3071
	],
	"9493": [
		"default",
		"./icons/InfoCircleOutlined",
		3071
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}